export enum AuditStatus {
  Created = 1,
  Modified = 2,
  Deleted = 3,
}
